// extracted by mini-css-extract-plugin
export var root = "styles-module--root--30-7W";
export var contentHolder = "styles-module--content-holder--vl7uR";
export var navigation = "styles-module--navigation--3n8Cg";
export var mobileNavigation = "styles-module--mobile-navigation--3RkQ2";
export var active = "styles-module--active--2M0u4";
export var toggleMenu = "styles-module--toggle-menu--3F031";